import { useQuery } from "react-query"
import { request } from "../util/request"

export function useBandPlayStats(bandId, startDate, endDate, postId = null) {
    return useQuery(["user_interactions", bandId, startDate, endDate, postId], getPlayStatsForBandId)
}

const getPlayStatsForBandId = async ({ queryKey }) => {
    const [ key, id, startDate, endDate, postId ] = [...queryKey]
    const params = { start_date: startDate, end_date: endDate }
    if (postId) params.post_id = postId
    return await request({
        queryKey: [
            key,
            {
                path: `/api/v1/bands/${id}/user_interactions`,
                params,
            }
        ]
    })
}
